<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

let search = ref("");
const suggestions = ref([]);
const loading = ref(false);
const error = ref(null);

async function fetchSuggestions() {
  loading.value = true;

  return fetch(process.env.VUE_APP_API_BASE_URL + "services/search?string=" + search.value, {
    method: "get",
    headers: {
      "content-type": "application/json",
    },
  })
    .then((r) => {
      if (!r.ok) {
        error.value = new Error(r.statusText);
        error.value.json = r.json();
        throw error;
      }

      return r.json();
    })
    .then((json) => {
      suggestions.value = json.data;
    })
    .catch((e) => {
      error.value = e;
      if (e.json) {
        return e.json.then((json) => {
          error.value.message = json.message;
        });
      }
    })
    .then(() => {
      loading.value = false;
    });
}

async function doSearch() {
  if ('' !== search.value) {
    router.push({ name: 'search-service', query: { 'string': search.value } });
  }
}
</script>

<template>
  <div>
    <input
      id="search-service-input"
      v-model="search"
      type="text"
      class="
        rounded-full
        px-5
        pr-12
        w-full
        text-sm
        py-[14px]
        bg-transparent
        border-[#e0e0e0]
        focus:border-[#e0e0e0] focus:ring-2 focus:ring-transparent
      "
      placeholder="Изготовление брекетов"
      @input="fetchSuggestions()"
    >
    <button
      class="
        rounded-full
        absolute
        right-[3px]
        tracking-[1px]
        top-[3px]
        text-sm
        py-[10px]
        px-[10px]
        border-2 border-green
        bg-green
        text-white
        hover:bg-[#2b9467] hover:border-[#2b9467]
      "
      @click="doSearch()"
    >
      <svg
        aria-hidden="true"
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </button>
    <ul class="w-full mt-1 px-3 text-sm text-left">
      <li
        v-for="suggest in suggestions"
        :key="suggest.id"
        class="
          rounded-full
          bg-white
          py-1
          mb-1
          px-4
          relative
          cursor-pointer
          hover:bg-[#2b9467] hover:border-[#2b9467] hover:text-white
        "
        @click="router.push({ name: 'search-by-service', params: { id: suggest.id } })"
      >
        →&nbsp;&nbsp;{{ suggest.name }} ({{ suggest.age_class.name }})
      </li>
    </ul>
  </div>
</template>

<style scoped>
#search-service-input {
  padding-right: 3rem;
}
</style>
